import { mdiAlertCircle, mdiCheck, mdiContentDuplicate, mdiProgressClock, mdiTimerSand } from '@mdi/js';

import { FileType } from './document';
import { DocumentUploadTag } from './tag';

export enum DocumentUploadStatusEnum {
	FAILED = 'FAILED',
	WAITING = 'WAITING',
	SENT = 'SENT',
	PROCESSED = 'PROCESSED',
	DUPLICATED = 'DUPLICATED',
}

enum DocumentUploadStatusLabelEnum {
	FAILED = 'Erreur',
	WAITING = 'En cours de dépôt',
	SENT = 'En attente de traitement',
	PROCESSED = 'Traité',
	DUPLICATED = 'Dupliqué',
}

const enumToLabelMap = new Map([
	[DocumentUploadStatusEnum.FAILED, DocumentUploadStatusLabelEnum.FAILED],
	[DocumentUploadStatusEnum.WAITING, DocumentUploadStatusLabelEnum.WAITING],
	[DocumentUploadStatusEnum.SENT, DocumentUploadStatusLabelEnum.SENT],
	[DocumentUploadStatusEnum.PROCESSED, DocumentUploadStatusLabelEnum.PROCESSED],
	[DocumentUploadStatusEnum.DUPLICATED, DocumentUploadStatusLabelEnum.DUPLICATED],
]);

const enumToIconMap = new Map([
	[DocumentUploadStatusEnum.FAILED, mdiAlertCircle],
	[DocumentUploadStatusEnum.WAITING, mdiTimerSand],
	[DocumentUploadStatusEnum.SENT, mdiProgressClock],
	[DocumentUploadStatusEnum.PROCESSED, mdiCheck],
	[DocumentUploadStatusEnum.DUPLICATED, mdiContentDuplicate],
]);

export const toDocumentUploadStatusLabelEnum = (documentUploadStatus: DocumentUploadStatusEnum) =>
	enumToLabelMap.get(documentUploadStatus);

export const toDocumentUploadStatusIconEnum = (documentUploadStatus: DocumentUploadStatusEnum) =>
	enumToIconMap.get(documentUploadStatus);

export type DocumentUploadType = {
	createdAt: Date;
	createdBy: string;
	fileType: FileType;
	id: string;
	status: DocumentUploadStatusEnum;
	name: string;
	tag: DocumentUploadTag;
};
